/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.currency-sign[_ngcontent-%COMP%]{width:22px;height:30px;display:flex;justify-content:center;align-items:center;font-size:14px;line-height:14px;color:#9da2bd;background-color:#f8f9fc;border:1px solid #e9ebf4;border-bottom-left-radius:4px;border-top-left-radius:4px}"];
export { styles as styles };
